// Pickit VoIP integration — endpoint config.
//
// The VoIP control-plane lives at a separate origin from the
// chatapp. It must be in CORS_ALLOW_ORIGINS server-side AND must
// trust this app's JWT_SECRET (configured via MYEXPERT_JWT_SECRET on
// the control-plane). When MYEXPERT_JWT_SECRET is shared, agents
// don't need a separate VoIP login — their existing chatapp token is
// validated and an agent row is auto-provisioned on first hit.

export const VOIP_API_BASE =
  (import.meta.env.VITE_VOIP_API_BASE as string | undefined) ??
  'https://voip.pickitsmartly.com'

// The VoIP admin portal (apps/admin-portal in the VoIP repo) is served
// on its own subdomain and embedded as an iframe in the /admin/voip tab.
// Its nginx frame-ancestors CSP whitelists app.chatelainxpert.be + the
// devcomplex dev hosts; the control-plane validates the chatapp JWT we
// pass via ?token= using the shared MYEXPERT_JWT_SECRET.
export const VOIP_ADMIN_BASE =
  (import.meta.env.VITE_VOIP_ADMIN_BASE as string | undefined) ??
  'https://admin.voip.pickitsmartly.com'
